import { StepState } from 'src/app/core/enums/enums';
import { ModuleSteps } from 'src/app/core/models/step.model';

export const alternativeWithsplitSteps = new ModuleSteps([
  { title: 'involuntary-change.steps.choose', state: StepState.Active },
  { title: 'involuntary-change.steps.split', state: StepState.Normal },
  { title: 'involuntary-change.steps.emergency-contact', state: StepState.Normal },
  { title: 'involuntary-change.steps.additional-documentation', state: StepState.Normal },
  { title: 'involuntary-change.steps.final', state: StepState.Normal },
  { title: 'involuntary-change.steps.seat-map', state: StepState.Normal }
]);

export const alternativeSteps = new ModuleSteps([
  { title: 'involuntary-change.steps.choose', state: StepState.Active },
  { title: 'involuntary-change.steps.emergency-contact', state: StepState.Normal },
  { title: 'involuntary-change.steps.additional-documentation', state: StepState.Normal },
  { title: 'involuntary-change.steps.final', state: StepState.Normal },
  { title: 'involuntary-change.steps.seat-map', state: StepState.Normal }
]);

export const airlineOptionSteps = new ModuleSteps([
  { title: 'involuntary-change.steps.airline', state: StepState.Completed },
  { title: 'involuntary-change.steps.final', state: StepState.Active }
]);

export const airlineOptionWithSplitSteps = new ModuleSteps([
  { title: 'involuntary-change.steps.airline', state: StepState.Completed },
  { title: 'involuntary-change.steps.split', state: StepState.Active },
  { title: 'involuntary-change.steps.final', state: StepState.Normal },
  { title: 'involuntary-change.steps.seat-map', state: StepState.Normal }
]);

export const alternativeStepsNewFlow = new ModuleSteps([
  { title: 'involuntary-change.steps.choose', state: StepState.Active },
  { title: 'involuntary-change.steps.aditionalInformation', state: StepState.Normal },
  { title: 'involuntary-change.steps.seat-map', state: StepState.Normal },
  { title: 'involuntary-change.steps.confirm-quote', state: StepState.Normal },
  { title: 'involuntary-change.steps.final', state: StepState.Normal },
  { title: 'voluntary-change.steps.reissue', state: StepState.Normal }
]);

export const alternativeStepsNewFlowWithSplitStep = new ModuleSteps([
  { title: 'involuntary-change.steps.choose', state: StepState.Active },
  { title: 'involuntary-change.steps.split', state: StepState.Normal },
  { title: 'involuntary-change.steps.aditionalInformation', state: StepState.Normal },
  { title: 'involuntary-change.steps.seat-map', state: StepState.Normal },
  { title: 'involuntary-change.steps.confirm-quote', state: StepState.Normal },
  { title: 'involuntary-change.steps.final', state: StepState.Normal },
  { title: 'voluntary-change.steps.reissue', state: StepState.Normal }
]);

export const stepsNewFlowWithReissue = new ModuleSteps([
  { title: 'involuntary-change.steps.choose', state: StepState.Active },
  { title: 'involuntary-change.steps.confirm-quote', state: StepState.Normal },
  { title: 'voluntary-change.steps.reissue', state: StepState.Normal }
]);
